export default "__VITE_PUBLIC_ASSET__5e6172c4__"